module.exports = __webpack_public_path__ + "public/img/w4.9a0ff187.png";